module.exports = __webpack_public_path__ + "static/AverageResponse-c18a4738c23f69f185932941fa82b714.png";